export default __webpack_public_path__ + "static/media/userExample.e6a3357c.png";